import type { Locale, Translate } from "../i18n/i18n";

// "5 минут назад" is not "5m ago" with a swapped word: Russian picks one of
// three plural forms and puts the unit differently, so the whole phrase comes
// from the dictionary and Intl decides the form.
export function formatRelativeTime(value: Date | string, t?: Translate, locale?: Locale): string {
  const date = value instanceof Date ? value : new Date(value);
  const elapsedMs = Date.now() - date.getTime();
  const say = t ?? fallback;

  if (elapsedMs < 45_000) return say("time.justNow");

  const minutes = Math.round(elapsedMs / 60_000);
  if (minutes < 60) return say("time.minutesAgo", { count: minutes });

  const hours = Math.round(minutes / 60);
  if (hours < 24) return say("time.hoursAgo", { count: hours });

  const days = Math.round(hours / 24);
  if (days < 7) return say("time.daysAgo", { count: days });

  const sameYear = date.getFullYear() === new Date().getFullYear();
  // No locale given means the browser's own — which is right far more often
  // than a hardcoded language would be.
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "short",
    ...(sameYear ? {} : { year: "numeric" }),
  }).format(date);
}

// Used only when a caller has no translator to hand; keeps the old English.
function fallback(key: string, params?: Record<string, number | string>): string {
  const count = Number(params?.count ?? 0);
  if (key === "time.justNow") return "just now";
  if (key === "time.minutesAgo") return `${count}m ago`;
  if (key === "time.hoursAgo") return `${count}h ago`;
  return `${count}d ago`;
}
